import { WorkspaceCreateField } from "@/components/shared/workspace-create-field";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { useRiderForm } from "./use-rider-form";

import type { Rider } from "@artisancode/api-types";

export function RiderDialog({
  open,
  onOpenChange,
  editing,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  editing: Rider | null;
}) {
  const { form, isSubmitting, onSubmit } = useRiderForm(open, editing, () =>
    onOpenChange(false),
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>{editing ? "Edit Rider" : "Tambah Rider"}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form id="rider-form" onSubmit={onSubmit} className="grid gap-3 py-2">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nama Rider</FormLabel>
                  <FormControl>
                    <Input placeholder="Nama rider" autoFocus {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <WorkspaceCreateField
              control={form.control}
              name="workspaceId"
              editing={!!editing}
            />
          </form>
        </Form>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Batal
          </Button>
          <Button type="submit" form="rider-form" disabled={isSubmitting}>
            {isSubmitting ? "Menyimpan..." : editing ? "Simpan" : "Tambah"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
